/** URL ?section= values and data-agent-highlight keys for rubric builder case file. */
export const RUBRIC_SECTION_IDS = [
  'describe',
  'dimensions',
  'focus',
  'requirements',
  'scoring',
  'domains',
  'test',
  'history',
] as const

export type RubricSectionId = (typeof RUBRIC_SECTION_IDS)[number]

export function rubricSectionHighlight(id: RubricSectionId): string {
  return `rubric-section-${id}`
}
